/// <amd-module name="Artifacts/Root/protocols/Redux" />

import { IProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import { IModuleTuple } from "redux-dynamic-modules";
import { IVssPageContext } from "VSS/Platform/Context";

export function getProtocolReduxModules(pageContext: IVssPageContext): IModuleTuple {
  const service: IProtocolService = pageContext.getService<IProtocolService>("IProtocolService");
  const protocolMap = service.getProtocolMapping();
  return Object.keys(protocolMap).map((key) => protocolMap[key].getReduxModule());
}
